// Sheet/modal open-close helpers, ported verbatim from the original app, plus the
// backdrop-click-to-close wiring that used to run once at boot via a querySelectorAll.
export function openSheet(id) { document.getElementById(id)?.classList.add('open'); }
export function closeSheet(id) { document.getElementById(id)?.classList.remove('open'); }
export function openModal(id) { document.getElementById(id)?.classList.add('open'); }
export function closeModal(id) { document.getElementById(id)?.classList.remove('open'); }

export function wireBackdrops() {
  document.querySelectorAll('.sheet-backdrop,.modal-backdrop').forEach(el => {
    el.addEventListener('click', e => {
      if (e.target === el) el.classList.remove('open');
    });
  });
}
